// Fidena-Logo: Hexagon-Symbol (public/logo-mark.png) + Wortmarke „Fidena" in
// der Editorial-Serif (Fraunces). Horizontales Lockup im App-Header, vertikales
// Lockup (Symbol über Wort, mit Champagner-Strich + Claim) auf der Login-Bühne.
// Hinweis: Das Klient-Portal nutzt NICHT dieses Logo, sondern das per-Tenant-
// Branding des jeweiligen Steuerberaters (ADR-024).

import "./Logo.css";

interface LogoProps {
  variant?: "header" | "large";
  withClaim?: boolean;
}

export function Logo({ variant = "header", withClaim = false }: LogoProps) {
  return (
    <div className={`bmd-logo bmd-logo-${variant}`}>
      <img
        className="bmd-logo-symbol"
        src="/logo-mark.png"
        alt=""
        aria-hidden="true"
      />
      <span className="bmd-logo-text">
        <span className="bmd-logo-wordmark">Fidena</span>
        {variant === "large" && (
          <span className="bmd-logo-rule" aria-hidden="true" />
        )}
        {withClaim && (
          <span className="bmd-logo-claim">Kanzlei-Automatisierung</span>
        )}
      </span>
    </div>
  );
}
